import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { buttonClasses, inputClasses } from 'styles/tailwindClassnames';

type SampleToSchemaPanelProps = {
  onGenerate: (sampleJson: string) => void;
};

export function SampleToSchemaPanel({ onGenerate }: SampleToSchemaPanelProps) {
  const { t } = useTranslation();
  const [sampleText, setSampleText] = useState('');
  const [error, setError] = useState<string | null>(null);

  function handleApply() {
    try {
      const parsedSample = JSON.parse(sampleText);
      if (
        typeof parsedSample !== 'object' ||
        parsedSample === null ||
        Array.isArray(parsedSample)
      ) {
        setError(t('Sample JSON must be a JSON object.'));
        return;
      }
      setError(null);
      onGenerate(sampleText);
    } catch {
      setError(t('Must be valid JSON.'));
    }
  }

  return (
    <div className="flex flex-col gap-3 p-4">
      <p className="text-body-sm text-ui-text-primary-text">
        {t(
          "Have a sample payload? Paste it here and we'll build the schema automatically.",
        )}
      </p>
      <textarea
        value={sampleText}
        onChange={(e) => {
          setSampleText(e.target.value);
          setError(null);
        }}
        placeholder={`{\n  "device_id": "abc-123",\n  "temperature": 25.3,\n  "timestamp": "2024-01-01T00:00:00Z"\n}`}
        className={`${inputClasses.textarea} min-h-[120px] resize-none font-mono text-body-sm`}
      />
      {error && (
        <p className="text-body-sm text-ui-status-error-destructive">{error}</p>
      )}
      <div className="flex gap-2">
        <button
          onClick={handleApply}
          disabled={!sampleText.trim()}
          className={buttonClasses.primarySm}
          type="button"
        >
          {t('Generate Schema')}
        </button>
      </div>
    </div>
  );
}
